// Import the functions you need from the SDKs you need

import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

// TODO: Add SDKs for Firebase products that you want to use

// https://firebase.google.com/docs/web/setup#available-libraries


// Your web app's Firebase configuration

// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
  apiKey: "AIzaSyAx9MYmUKKbN5F8-RWZsZLlv0a_uPK_V04",
  authDomain: "web-sitolaut-barang.firebaseapp.com",
  projectId: "web-sitolaut-barang",
  storageBucket: "web-sitolaut-barang.appspot.com",
  messagingSenderId: "1013657924809",
  appId: "1:1013657924809:web:ef4f1887fc5a1a1602c918",
  measurementId: "G-F0MT6VRRC6"
};


// Initialize Firebase

const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
